import Model from "../Model";

class InvestmentControlInvestmentBilled extends Model {
    buildUrl ({query}) {
        return ['api/investment-control/investment-billed'];
    }
};

export default new InvestmentControlInvestmentBilled;